export default __webpack_public_path__ + "static/media/signin-background.1ae7386a.jpg";